import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetCoddingProfile = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getAllCoddingProfile = () => {
    setLoading(true);

    axiosClient
      .get(`SettingProduct/CoddingProfile/GetAll`)
      .then(res => {
        if (res.status === 200) {
          setData(res.data.value);
          setFailed(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
          setFailed(true);
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
        setFailed(true);
      })
      .finally(() => setLoading(false));
  };

  return [getAllCoddingProfile, loading, failed, data];
};

export default useGetCoddingProfile;
